__turbopack_context__.v({
  "container-main": "AppHome-module-sass-module__apPYiq__container-main",
  "container-main-wrapper": "AppHome-module-sass-module__apPYiq__container-main-wrapper",
  "cover-roll-section": "AppHome-module-sass-module__apPYiq__cover-roll-section",
  "delivery-rests-slider-roll": "AppHome-module-sass-module__apPYiq__delivery-rests-slider-roll",
  "filters": "AppHome-module-sass-module__apPYiq__filters",
  "main-section": "AppHome-module-sass-module__apPYiq__main-section",
});
